import styled, { css } from 'styled-components';

import withParallax from 'utils/parallax';
import { media } from 'utils/detection';

export default styled(withParallax(styled.p`
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0;
  margin: 0;

  ${media.medium`
    font-size: 1rem;
    white-space: nowrap;
  `}
`))`
  margin: 7px 0 0 0;

  ${media.medium`
    margin: -5px 0 0 0;

    ${props => props.projectName && css`
      margin: 12px 0 0 0;
    `}
  `}
`;
